<template>
  <div>
    <el-upload
      ref="upload1"
      class="upload" v-bind:class="{uploadNoEdit:disabled}"
      :action=url
      :on-remove="handleRemove"
      :before-remove="handleBeforeRemove"
      :on-preview="handlePreview"
      :before-upload="handleBeforeUpload"
      :on-exceed="handleExceed"
      :on-success="handleSuccess"
      :data="data"
      :drag="drag"
      :headers="headers"
      :show-file-list="showFileList"
      :limit="limit"
      :accept="accept"
      :maxSize="maxSize"
      :disabled="disabled"
      :list-type="getListType()"
      :multiple="multiple"
      :file-list="fileList">
      <el-button size="small" type="primary" v-if="!drag&&!disabled">点击上传</el-button>
      <label role="checkbox" class="el-checkbox" @click.stop.prevent="EnableDrawimg()" style="padding-left: 30px"
             v-if="ShowEnableDrawImage">
        <span aria-checked="mixed" class="el-checkbox__input" v-bind:class="{'is-checked':EnableDrawImage}"><span
          class="el-checkbox__inner"></span><input type="checkbox" aria-hidden="true" class="el-checkbox__original"
                                                   value="200"></span><span class="el-checkbox__label">禁用图片压缩
        <!----></span></label>
      <div>
        <i class="el-icon-upload" v-if="drag&&!disabled" style="line-height: 30px !important;"></i>
        <p class="el-upload__text" v-if="drag&&!disabled" style="line-height: 30px !important;">将文件拖到此处，或<em
          style="line-height: 30px !important;">点击上传</em></p>
      </div>
      <div slot="tip" class="el-upload__tip">{{tip}}</div>
    </el-upload>
    <el-dialog custom-class="max-dialog" :visible.sync="dialogVisible" :append-to-body="true">
      <img :src="dialogImageUrl" alt="">
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button type="info" @click="openUrl(dialogImageUrl)">下载</el-button>
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
  import {getListData, deleteData, uploadUrl, commonUpload} from '@/api/attachment'

  export default {
    name: "user",
    data() {
      return {
        ONLoad: 0,
        url: uploadUrl,
        NOCheckRemove: false,
        EnableDrawImage: false,
        ShowEnableDrawImage: true,
        dialogVisible: false,
        dialogImageUrl: "",
        OpenURL: "",
        AddFlag: false,
        data: {
          groupGuid: this.groupGuid,
          groupType: this.groupType,
          allowOpen: this.allowOpen,
          fileName: '',
          fixedFileName: this.fixedFileName,
          goodsseedcode:this.goodsseedcode,
        },
        headers: {
          token: "",
          timestamp: "",
          deviceid: "",
          os: "",
          sign: ""
        },
        fileList: []
      }
    },
    props: {
      groupGuid: {
        default: ""
      },
      showList: {
        default: true
      },
      groupType: {     //必填
        default: ""
      },
      fixedFileName: {//固定的附件名称
        default: ""
      },
      allowOpen: {
        default: false,
      },
      enableImgDialog: {//是否启用照片墙弹出框，只有fileType=img模式下有效
        default: false
      },
      listType: {   // 文件列表类型，默认text，可选值 text/picture/picture-card，分别对应文本列表、缩略图列表、图片卡片列表 。 此属性必须与在isNeedRealPath=true时有效
        default: "text"     //只有fileType=img模式下，后2中模式才有效，  word文档等文件没有缩略图
      },
      drag: {//是否启用拖拽上传
        default: false
      },
      imgMaxSize: {//图片的最大宽度 高度
        default: 1024
      },
      tip: {         //提示
        default: '' //.例如  只能上传jpg/jpeg/png文件
      },
      fileType: { //文件模式，例如图片模式。 可选值  img 或者 other
        default: ""  //
      },
      accept: {
        default: ""  // 例如 .png,.jpg,.jpeg
      },
      showFileList: {
        default: true
      },
      limit: {//最大允许上传个数
        default: 99
      },
      maxSize: {  //文件最大值    ，以M为单位
        default: "30"
      },
      disabled: {//禁用
        default: false
      },
      multiple: {//是否能多选文件
        default: true
      },
      goodsseedcode:{
        default: ''
      }
    },
    //
    watch: {
      groupGuid(val, oldval) {
        if (val == "") {
          return;
        }
        this.bindData(val);
      },
    },
    methods: {
      EnableDrawimg() {
        if (this.EnableDrawImage)
          this.EnableDrawImage = false;
        else
          this.EnableDrawImage = true;
      },
      reset() {
        this.fileList = []
        this.$refs.upload1.clearFiles()
      },
      getFiles() {
        return this.fileList;
      },
      getListType() {
        if (this.fileType == "img" && this.allowOpen) {
          //公开的图片才能使用card模式
          if (this.listType == 'picture-card')
            this.ShowEnableDrawImage = false;
          return this.listType;
        }
        return "text";
      },
      bindData(uguid) {
        this.ONLoad = 0;
        if (uguid && uguid != '')
          this.data.groupGuid = uguid;
        if (!this.data.groupGuid || this.data.groupGuid == '' || !this.groupType) {
          return;
        }
        this.fileList = []
        if(this.showList) {
          getListData(this.data).then((result) => {
            for (let i in result.data.obj) {
              this.fileList.push({
                "name": result.data.obj[i]["filename"],
                "url": result.data.obj[i]["virtualpath"],
                "size": result.data.obj[i]["filesize"]
              })
            }
            this.afterBind()
          })
        }
      },
      handleSuccess(response, file, fileList) {
        if (response.code == 1) {
          this.$message({
            message: response.msg,
            type: 'warning'
          });
        } else {
          this.ONLoad = this.ONLoad - 1;
          if (this.ONLoad <= 0)
            this.bindData();
          //先删除同名
          // for(var i=0;i<this.fileList.length;i++){
          //   if(this.fileList[i].name==response.filename) {
          //     this.fileList.splice(i, 1);
          //     break;
          //   }
          // }
          // var NewItem={"name": response.filename,
          //   "url": response.url,
          //   "size": 0};
          // this.fileList.splice(200, 1, NewItem);
        }
      },
      handleExceed(files, fileList) {
        this.$message({
          message: '最多上传' + this.limit + "个文件",
          type: 'warning'
        });
      },
      checkFileExt(filename) {
        var flag = false; //状态
        if (this.accept == '')
          return true;
        var arr = this.accept.split(',');
        //取出上传文件的扩展名
        var index = filename.lastIndexOf(".");
        var ext = filename.substr(index + 1).toLowerCase();
        //循环比较
        for (var i = 0; i < arr.length; i++) {
          if (ext == arr[i] || '.' + ext == arr[i]) {
            flag = true; //一旦找到合适的，立即退出循环
            break;
          }
        }
        return flag;
      },
      handleBeforeRemove(file, filelist) {
        if (this.NOCheckRemove) {
          this.NOCheckRemove = false;
          return true;
        }
        this.data.fileName = file.name;

        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.data.goodsseedcode=this.goodsseedcode
          deleteData(this.data).then((result) => {
            if (result.data.code == 1) {
              this.$message({
                type: 'info',
                message: '删除失败'
              });
            } else {
              for (var i = 0; i < this.fileList.length; i++) {
                if (this.fileList[i].name == this.data.fileName) {
                  this.fileList.splice(i, 1);
                  break;
                }
              }
              this.afterBind()
            }
          });

        });
        return false;
      },
      afterBind(){
        try {
          this.$emit("afterBind", this.fileList)   //抛出事件,
        } catch (ex) {

        }
      },
      handleRemove(file, filelist) {

      },
      handleBeforeUpload(file) {
        if (!this.data.groupGuid || !this.groupType) {
          this.$message({message: '请设置groupGuid和groupType属性', type: 'warning'});
          this.NOCheckRemove = true;
          return false;
        } else {
          if (this.maxSize) {
            const size1 = file.size / 1024 / 1024
            if (size1 > this.maxSize) {
              this.$message({
                message: '文件超过' + this.maxSize + "M，请重新选择文件上传",
                type: 'warning'
              });
              this.NOCheckRemove = true;
              return false;
            }
          }

          if (!this.checkFileExt(file.name)) {
            this.$message({
              message: '只允许上传格式为' + this.accept + '的文件！',
              type: 'warning'
            });
            this.NOCheckRemove = true;
            return false;
          }
        }

        this.DrawImage(file);

        //自己写上传方法
        this.NOCheckRemove = true;
        return false;
      },
      handlePreview(file) {
        var arrs=file.name.split('.');
        var endextend=file.name.split('.')[arrs.length-1].toLowerCase();
        if ((this.enableImgDialog && this.fileType == "img")||endextend=='png'||endextend=='jpg'||endextend=='jpeg'||endextend=='gif'||endextend=='bmp') {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        } else {
          if (file.url == '') {
            return;
          }
          window.open(file.url, "");
        }
      },
      openUrl(url){
        window.open(url, "");
      },
      DrawImage(file) {
        // 压缩图片需要的一些元素和对象
        var self = this;
        var reader = new FileReader(),
          img = new Image();
        // 选择的文件是图片
        if (file.type.indexOf("image") == 0 && !self.EnableDrawImage) {
          reader.readAsDataURL(file);
        } else {
          this.PostFile(file);
          return;
        }

        // 文件base64化，以便获知图片原始尺寸
        reader.onload = function (e) {
          img.src = e.target.result;
        };

        // 缩放图片需要的canvas
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        // base64地址图片加载完毕后
        img.onload = function () {
          // 图片原始尺寸
          var originWidth = this.width;
          var originHeight = this.height;
          // 最大尺寸限制
          var maxWidth = self.imgMaxSize,
            maxHeight = self.imgMaxSize;
          if (maxWidth >= originWidth && maxHeight >= originHeight) {
            self.PostFile(file);
            return;
          } else {
            // 目标尺寸
            var targetWidth = originWidth,
              targetHeight = originHeight;

            if (originWidth > maxWidth || originHeight > maxHeight) {
              if (originWidth / originHeight > maxWidth / maxHeight) {
                // 更宽，按照宽度限定尺寸
                targetWidth = maxWidth;
                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
              } else {
                targetHeight = maxHeight;
                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
              }
            }

            // canvas对图片进行缩放
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            // 清除画布
            context.clearRect(0, 0, targetWidth, targetHeight);
            // 图片压缩
            context.drawImage(img, 0, 0, targetWidth, targetHeight);
            // canvas转为blob并上传
            canvas.toBlob(function (blob) {
              //在这里实现上传操作
              blob.name = file.name;
              self.PostFile(blob);
            }, file.type || 'image/png');
          }
        };
      },
      PostFile(file) {
        var NoReName = true;
        var NewFile = {name: file.name, url: '', size: 0};
        //先删除同名
        if (this.data.fixedFileName != '') {
          if (this.fileList.length > 0) {
            NoReName = false;
            NewFile = this.fileList[0];
          }
          //this.fileList.splice(0, 1);//只能传一个
        } else {
          for (var i = 0; i < this.fileList.length; i++) {
            if (this.fileList[i].name == file.name) {
              NewFile = this.fileList[i];
              NoReName = false;
              break;
            }
          }
        }
        // }
        // var NewItem={"name": response.filename,
        //   "url": response.url,
        //   "size": 0};
        // this.fileList.splice(200, 1, NewItem);

        commonUpload(file, this.data.groupGuid, this.data.groupType, this.data.allowOpen, this.data.fixedFileName,this.data.isbatchsave).then(response => {
          if (!response || response.code == 1) {
            this.$message({
              message: response ? response.msg : file.name + '上传失败！',
              type: 'warning'
            });
          } else {
            if (NoReName) {
              this.fileList.push(NewFile);
            }
            NewFile.url = response.data.url;
            if(response.data.groupGuidnew){
              this.$emit("afterupload",response.data.groupGuidnew)
            }
            try {
              this.$emit("emitNewFile", NewFile)   //新增事件,
            } catch (ex) {

            }
            this.afterBind()
          }
        });
      },
    },
    computed: {},
    mounted() {
      if (this.groupGuid) {
        this.bindData(this.groupGuid);
      }
    },
  }
</script>


<style scoped>
  .upload div {
    line-height: 30px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/CommonUpload.vue